<template>
  <div
    class="Overlay"
    data-action="close-modal"
    @click.self="closeModal"
    v-if="visible"
  >
    <div class="ModalBox ModalBox--central Modal--filters">
      <div class="ModalBox-header d-flex justify-content-between align-items-center position-absolute p-3">
        <div class="Tit Tit--modal position-absolute w-100">
          <span v-t="{path : 'customers_funds_transfer_modal_header'}"></span>
        </div>
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#close-icon"></use>
          </svg>
        </div>
      </div>
      <div class="ModalBox-container position-relative pl-3 pr-5 pt-3">
        <i18n
          tag="p"
          class="Fuell-Text mt-5 ml-3"
          path="customers_transfer_funds_to_bank_account_message"
        >
          <template v-slot:customerName>
            <span class="text-danger">{{customer.name}}</span>
          </template>
        </i18n>
        <div class="col-12">
          <div class="input--block input--block--margin input--block--padded">
            <label
              for=""
              class="form--label u-required"
            >{{$t('customer_amount_to_transfer').toUpperCase()}}</label>
            <div
              class="Form-field"
              :class="{'input--error' : $v.transferData.amount.$error}"
            >
              <currency-input
                :class="'Input-text'"
                :allow-negative="false"
                :placeholder="$t('customer_amount_to_transfer')"
                @blur="$v.transferData.amount.$touch()"
                v-model="transferData.amount"
              ></currency-input>

            </div>
          </div>

        </div>

        <div class="col-12">
          <div class="input--block input--block--margin input--block--padded">
            <label
              for=""
              class="form--label u-required"
            >
              {{$t('customer_transfer_concept').toUpperCase()}}
            </label>
            <div
              class="Form-field"
              :class="{'input--error' : $v.transferData.concept.$error}"
            >
              <input
                type="text"
                name=""
                id=""
                class="Input-text"
                :placeholder="$t('customer_transfer_concept')"
                @blur="$v.transferData.concept.$touch()"
                v-model.trim="transferData.concept"
              >
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="input--block input--block--margin input--block--padded">
            <label
              for=""
              class="form--label u-required"
            >{{$t('customer_transfer_iban_bank_number').toUpperCase()}}</label>
            <div
              class="Form-field"
              :class="{'input--error' : $v.iban.$error}"
            ><input
                type="text"
                :placeholder="$t('customer_transfer_iban_bank_number')"
                class="Input-text"
                @blur="$v.iban.$touch()"
                @input="replaceDots"
                v-model.trim="iban"
              ></div>
          </div>
        </div>
        <div class="col-12">
          <div class="input--block input--block--margin input--block--padded">
            <label
              for=""
              class="form--label u-required"
            >{{$t('customer_transfer_beneficiary_name').toUpperCase()}}</label>
            <div
              class="Form-field"
              :class="{'input--error' : $v.transferData.beneficiaryName.$error}"
            >
              <input
                type="text"
                :placeholder="$t('customer_transfer_beneficiary_name')"
                class="Input-text"
                @blur="$v.transferData.beneficiaryName.$touch()"
                v-model.trim="transferData.beneficiaryName"
              >
            </div>
          </div>
        </div>

        <div class="col-12 mt-3">
          <p class="Fuell-Text text-danger mb-0"> Ésta operación requiere que introduzcas la clave de seguridad y el One Time Password (OTP) que recibirás por SMS</p>
          <div class="input--block input--block--margin input--block--padded">
            <label
              for=""
              class="form--label u-required"
            >{{$t('PASSCODE').toUpperCase()}}</label>
            <div
              class="Form-field"
              :class="{'input--error' : $v.transferData.passcode.$error}"
            >
              <input
                type="password"
                class="Input-text"
                :placeholder="$t('PASSCODE')"
                autocomplete="new-password"
                @blur="$v.transferData.passcode.$touch()"
                v-model="transferData.passcode"
              >
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row d-flex justify-content-between align-items-center">

            <div class="col-9">
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label u-required"
                >{{$t('OTP').toUpperCase()}}</label>
                <div class="Form-field">
                  <input
                    type="password"
                    class="Input-text"
                    :placeholder="$t('OTP')"
                    autocomplete="new-password"
                    v-model="transferData.otp"
                  >
                </div>
              </div>
            </div>
            <button
              class="col-3 mt-4 Fuell-Button blue"
              :disabled="isCallingApi"
              @click="generateOTP"
            ><span class="Fuell-Button--label">{{$t('customer_actions_request_otp_action')}}</span></button>
          </div>
        </div>
        <small
          class="col-12 mt-1"
          v-if="otpSuccessFlag"
        >{{$t('customer_actions_otp_requested_warning')}}</small>

        <div class="col-12 d-flex justify-content-center my-4">
          <button
            v-if="!isCallingApi"
            @click="showConfirmModal"

            :disabled="!canBeSubmitted && !isCallingApi"
            class="Fuell-Button block blue w-50"
          >{{$t('ACTION_SEND')}}</button>
          <div
            class="d-flex flex-column justify-content-center"
            v-else
          >
            <div class="mx-auto">
              <Spinner />
            </div>
            <span>{{$t('ACTION_SENDING')}}</span>
          </div>

        </div>

      </div>
    </div>
    <confirm-modal
      :open.sync="showConfirmModalFlag"
      @dismiss="closeModal"
      @accept="submitTransfer"
      v-if="showConfirmModalFlag"
      :title="'customers_funds_transfer_modal_header'"
      :acceptText="'customers_funds_transfer_modal_confirm_transfer'"
    ></confirm-modal>
  </div>
</template>

<script>
import customersApi from '../../_api'
import usersApi from '@/modules/users/_api'

import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import { CurrencyInput } from 'vue-currency-input'
import Spinner from '@/components/Commons/Spinner'

import { alphaNumSpace } from '@/utils/customValidations'
const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'CustomerFundsTransferModal',
  mixins: [_modalHandlerMixin, validationMixin],
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  components: {
    CurrencyInput, Spinner, ConfirmModal
  },
  computed: {
    canBeSubmitted () {
      return !this.$v.$invalid
    },
    loggedUserId () {
      return this.$store.getters['LoginStore/user'].id || false
    }

  },
  data () {
    return {
      transferData: {
        amount: null,
        passcode: null,
        concept: null,
        iban: null,
        beneficiaryName: null,
        otp: null
      },
      isCallingApi: false,
      showConfirmModalFlag: false,
      otpSuccessFlag: false,
      iban: null

    }
  },
  methods: {
    showConfirmModal () {
      this.showConfirmModalFlag = true
    },
    replaceDots () {
      this.iban = this.iban.split('.').join('')
    },
    async submitTransfer () {
      try {
        if (this.isCallingApi) return
        this.isCallingApi = true
        this.transferData.iban = this.iban.split(' ').join('')

        await customersApi.putCustomerIbanTransfer(this.customer.id, this.transferData)

        this.$store.dispatch('SnackBars/addSuccess', this.$t('customers_bill_client_success'), { root: true })
        this.closeModal()
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'customers_bill_client_error' }, { root: true })
      } finally {
        this.isCallingApi = false
      }
    },
    async generateOTP () {
      try {
        if (this.isCallingApi) return
        this.isCallingApi = true
        await usersApi.putUserGenerateOneTimePassword(this.loggedUserId)
        this.$store.dispatch('SnackBars/addSuccess', this.$t('superadmin_generate_otp_success'), { root: true })
      } catch (error) {
        this.$store.dispatch('SnackBar/addErrorHandler', { error: error, errorMessage: 'superadmin_generate_otp_error' }, { root: true })
      } finally {
        this.isCallingApi = false
      }
    }
  },
  validations: {
    transferData: {
      amount: { required },
      passcode: { required },
      concept: { required },
      beneficiaryName: { required },
      otp: { required }
    },
    iban: { required, alphaNumSpace }

  }
}
</script>
